/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ICycleDay } from 'app/shared/model/cycle-day.model';
import { PainLevel } from 'app/shared/model/enumerations/pain-level.model';

export interface IPain {
  id?: string;
  cramps?: boolean | null;
  crampLevel?: keyof typeof PainLevel | null;
  ovulationPain?: boolean | null;
  opLevel?: keyof typeof PainLevel | null;
  headache?: boolean | null;
  headacheLevel?: keyof typeof PainLevel | null;
  backache?: boolean | null;
  backacheLevel?: keyof typeof PainLevel | null;
  nausea?: boolean | null;
  nauseaLevel?: keyof typeof PainLevel | null;
  tenderBreasts?: boolean | null;
  migraine?: boolean | null;
  migraneLevel?: keyof typeof PainLevel | null;
  other?: boolean | null;
  comments?: string | null;
  active?: boolean | null;
  draft?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  cycleDay?: ICycleDay | null;
}

export const defaultValue: Readonly<IPain> = {
  cramps: false,
  ovulationPain: false,
  headache: false,
  backache: false,
  nausea: false,
  tenderBreasts: false,
  migraine: false,
  other: false,
  active: false,
  draft: false,
};
